export enum STEP_MODE {
  AUTH,
  DENY,
}
